import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allowedModulePermissions: [],
  allModulePermissions: {},
  modulePermissions: {},
  scopePermissions: {},
  allPermissions: {},
  error: null,
};

const permissionSlice = createSlice({
  name: 'permissionsStorage',
  initialState,
  reducers: {
    setReducerError: (state, action) => {
      state.error = action.error;
    },
    resetAllModulePermissions: (state, action) => {
      state.allModulePermissions = {};
    },
    setAllModulePermissions: (state, action) => {
      // Ensure `allModulePermissions` is initialized as an object
      if (!state.allModulePermissions) {
        state.allModulePermissions = {};
      }

      // Ensure the specific key is initialized as an object before setting the value
      if (!state.allModulePermissions[action.payload.key]) {
        state.allModulePermissions[action.payload.key] = {};
      }

      // Set the value for the specific key
      state.allModulePermissions[action.payload.key] = action.payload.value;
    },
    setAllowedModulePermissions: (state, action) => {
      state.allowedModulePermissions = action.payload;
      state.error = null;
    },
    setModulePermissions: (state, action) => {
      state.modulePermissions = action.payload;
      state.error = null;
    },
    setScopePermissions: (state, action) => {
      state.scopePermissions = action.payload;
      state.error = null;
    },
    setAllPermissions: (state, action) => {
      state.allPermissions = action.payload;
      state.error = null;
    },
    setResetPermissions: () => {
      return initialState;
    },
  },
});

export const {
  setReducerError,
  setAllowedModulePermissions,
  resetAllModulePermissions,
  setAllModulePermissions,
  setModulePermissions,
  setScopePermissions,
  setAllPermissions,
  setResetPermissions,
} = permissionSlice.actions;

export default permissionSlice.reducer;
